<template>
  <div class="layout">
    <v-layout class="position-relative">
      <v-main :style="`padding-top: ${windowWidth <= 1323 ? '10px' : '65px'}`">
        <slot></slot>
      </v-main>
      <AppNav v-show="windowWidth > 1323" />
      <ResponsiveNav v-show="windowWidth <= 1323" />
      <AppFooter />
    </v-layout>
  </div>
</template>
<script>
import AppNav from "./AppNav.vue";
import AppFooter from "./AppFooter.vue";
import ResponsiveNav from "./ResponsiveNav.vue";
export default {
  //1323
  data: () => ({
    drawer: true,
    windowWidth: 0,
  }),
  components: {
    AppNav,
    AppFooter,
    ResponsiveNav,
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
      //console.log(this.windowWidth);
    };
  },
};
</script>
